import React, { useEffect } from 'react';
import cn from 'classnames';

import CircleDeclined from 'assets/icons/circle-declined.svg';
import './style.scss';

const Decline = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    window.top.postMessage(
      {
        isSuccess: false,
      },
      '*'
    );
  });

  return (
    <section className="container section">
      <div className={cn('grid-container fluid', 'borrowers-message')}>
        <div className="grid-container">
          <div className="grid-x grid-margin-x max-limited">

            <div className="cell small-12 large-8 large-offset-2">
              <img src={CircleDeclined} alt="declined" />
              <h2>
                Error!
                <br />
                Application submission failed!
              </h2>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Decline;
